var map = {
	"./assets/clickable/discord.svg": "2b29ca369e72c5d5f7a5",
	"./assets/disabled/discord.svg": "df617c7ca1b86ebb2af4",
	"./assets/original/discord.svg": "38291f2b1010841b1af6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61e117823ff54158919b";